import { render, staticRenderFns } from "./downloadImageModal.vue?vue&type=template&id=20f7cae1&scoped=true&"
import script from "./downloadImageModal.vue?vue&type=script&lang=js&"
export * from "./downloadImageModal.vue?vue&type=script&lang=js&"
import style0 from "./downloadImageModal.vue?vue&type=style&index=0&id=20f7cae1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7cae1",
  null
  
)

export default component.exports